<template>
    <div
        :class="{
            'home zh-cn': lang === 'zh-cn',
            'home zh-cht': lang === 'zh-cht',
            'home en-us': lang === 'en-us',
            'home ja-jp': lang === 'ja-jp',
            'home ko-kr': lang === 'ko-kr',
        }"
        id="home"
    >
        <div class="topFixed">
            <div class="top">
                <h1 class="logo" @click="link('m_1')">
                    <img
                        v-if="lang == 'zh-cn'"
                        src="@/assets/imgs/logo.png"
                        :alt="langConfig.h1"
                        width="100%"
                    />
                    <img
                        v-else-if="lang == 'zh-cht'"
                        src="@/assets/imgs/tc/logo.png"
                        :alt="langConfig.h1"
                        width="100%"
                    />
                    <img
                        v-else
                        src="@/assets/imgs/es/logo.png"
                        :alt="langConfig.h1"
                        width="100%"
                    />
                    <!-- {{ langConfig.h1 }} -->
                </h1>
                <ul class="nav">
                    <li
                        :class="navIndex == 1 ? 'on' : ''"
                        @click="link('m_1')"
                        @mouseover="navIndex = 0"
                    >
                        <p>{{ langConfig.nav[0] }}</p>
                        <span></span>
                    </li>
                    <li
                        :class="navIndex == 2 ? 'on' : ''"
                        @click="link('m_2')"
                        @mouseover="navIndex = 0"
                    >
                        <p>{{ langConfig.nav[1] }}</p>
                        <span></span>
                    </li>
                    <li
                        :class="navIndex == 3 ? 'on' : ''"
                        @click="link('m_3')"
                        @mouseover="navIndex = 0"
                    >
                        <p>{{ langConfig.nav[2] }}</p>
                        <span></span>
                    </li>
                    <li
                        :class="navIndex == 4 ? 'on' : ''"
                        @click="link('m_4')"
                        @mouseover="navIndex = 0"
                    >
                        <p>{{ langConfig.nav[3] }}</p>
                        <span></span>
                    </li>
                    <li
                        :class="navIndex == 5 ? 'on' : ''"
                        @click="link('m_5')"
                        @mouseover="navIndex = 0"
                    >
                        <p>{{ langConfig.nav[4] }}</p>
                        <span></span>
                    </li>
                </ul>
                <!-- <div class="lang-nav">
					<ul>
						<li :class="lang == 'zh-cn'? 'on' : ''"><a @click="setLang('zh-cn')">{{ langConfig.nav2[0] }}</a></li>
						<li :class="lang == 'zh-cht'? 'on' : ''"><a @click="setLang('zh-cht')">{{ langConfig.nav2[1] }}</a></li>
						<li :class="lang == 'en-us'? 'on' : ''"><a @click="setLang('en-us')">{{ langConfig.nav2[2] }}</a></li>
						<li :class="lang == 'ja-jp'? 'on' : ''"><a @click="setLang('ja-jp')">{{ langConfig.nav2[3] }}</a></li>
						<li :class="lang == 'ko-kr'? 'on' : ''"><a @click="setLang('ko-kr')">{{ langConfig.nav2[4] }}</a></li>
					</ul>
				</div> -->
            </div>
        </div>
        <div class="mian">
            <div class="m m_1" id="m_1">
                <img src="@/assets/imgs/banner/bg_3.jpg" width="100%" />
                <img src="@/assets/imgs/banner/bg_3.png" width="100%" />
                <!-- <img src="@/assets/imgs/banner/bg_3.png" width="100%"/> -->
                <img src="@/assets/imgs/banner/bg_1.png" width="100%" />
                <!-- <img class="animated shakeY2 infinite" style="animation-duration: 18s; animation-delay: 0.8s;" src="@/assets/imgs/banner/bg_2_zh.png" /> -->
                <img
                    v-if="lang == 'zh-cn'"
                    src="@/assets/imgs/banner/bg_2_zh.png"
                />
                <img
                    v-else-if="lang == 'zh-cht'"
                    src="@/assets/imgs/banner/bg_2_cht.png"
                />
                <img v-else src="@/assets/imgs/banner/bg_2_en.png" />

                <!-- <img v-if="lang == 'zh-cn'" src="@/assets/imgs/banner/bg_2_zh.png" class="animated shakeY2 infinite transitionIcon" :class="m1iconShow? 'on':''" style="animation-duration: 23s; animation-delay: 0s;"/>
				<img v-else-if="lang == 'zh-cht'" src="@/assets/imgs/banner/bg_2_cht.png" class="animated shakeY2 infinite transitionIcon" :class="m1iconShow? 'on':''" style="animation-duration: 23s; animation-delay: 0s;"/>
				<img v-else src="@/assets/imgs/banner/bg_4_en.png" class="animated shakeY2 infinite transitionIcon" :class="m1iconShow? 'on':''" style="animation-duration: 23s; animation-delay: 0s;"/> -->

                <div
                    class="m_1_icon"
                    @mouseover="m1iconShow = true"
                    @mouseout="m1iconShow = false"
                >
                    <!-- <div class="m_1_icon_icon1 animated shakeX infinite transitionIcon" style="animation-duration: 18s; animation-delay: 0.8s;" :class="m1iconShow? 'on':''"> -->
                    <div
                        class="m_1_icon_icon1 transitionIcon"
                        :class="m1iconShow ? 'on' : ''"
                    >
                        <span></span>
                        <span></span>
                        <!-- <span class="animated shakeY infinite transitionIcon" :class="m1iconShow? 'on':''" style="animation-delay: 0.8s;"></span>
						<span class="animated shakeY infinite transitionIcon" :class="m1iconShow? 'on':''" style="animation-delay: 1.2s;"></span> -->
                    </div>
                    <!-- <div class="m_1_icon_icon2 animated shakeY infinite transitionIcon" :class="m1iconShow? 'on':''" style="animation-delay: 1.1s;"></div> -->
                    <div
                        class="m_1_icon_icon2 transitionIcon"
                        :class="m1iconShow ? 'on' : ''"
                    ></div>
                    <!-- <div class="m_1_icon_icon3 animated shakeX infinite transitionIcon" :class="m1iconShow? 'on':''" style="animation-delay: 1.6s;"></div> -->
                    <div
                        class="m_1_icon_icon3 transitionIcon"
                        :class="m1iconShow ? 'on' : ''"
                    ></div>
                </div>
            </div>
            <div class="m m_2" id="m_2">
                <div class="m_c m_2_c">
                    <div class="m_c_title m_2_c_title">
                        <span>{{ langConfig.m2.entitle }}</span>
                        <p>{{ langConfig.m2.title }}</p>
                    </div>
                    <div class="m_2_c_c">
                        <div class="m_2_c_c_l">
                            <div class="swiperC">
                                <!-- <img src="@/assets/imgs/pic/pic_1_2.jpg" alt="轮播图1"> -->
                                <img
                                    src="@/assets/imgs/pic/pic_1_2.jpg"
                                    alt="轮播图1"
                                />
                                <!-- <swiper :options="swiperOption" ref="mySwiper1"> -->
                                <!-- slides -->
                                <!-- <swiper-slide><img src="@/assets/imgs/pic/pic_1_2.jpg" alt="轮播图1"></swiper-slide> -->
                                <!-- <swiper-slide><img src="@/assets/imgs/pic/pic_1_2.jpg" alt="轮播图2"></swiper-slide>
									<swiper-slide><img src="@/assets/imgs/pic/pic_1_2.png" alt="轮播图3"></swiper-slide> -->
                                <!-- Optional controls -->
                                <!-- </swiper> -->
                            </div>
                        </div>
                        <div class="m_2_c_c_r">
                            <div class="m_2_c_c_r_title">
                                <p v-html="langConfig.m2.info1"></p>
                                <span>{{ langConfig.m2.info2 }}</span>
                            </div>
                            <div class="m_2_c_c_r_text">
                                <p v-html="langConfig.m2.info3"></p>
                                <p v-html="langConfig.m2.info4"></p>
                                <!-- <a :href="langConfig.m2.info7" target="_blank">{{langConfig.m2.info6}}</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m m_3" id="m_3">
                <div class="m_c m_3_c">
                    <div class="m_3_c_l">
                        <div class="m_c_title m_3_c_l_title">
                            <span>{{ langConfig.m3.entitle }}</span>
                            <p>{{ langConfig.m3.title }}</p>
                        </div>
                        <div class="m_3_c_l_text">
                            <p v-html="langConfig.m3.info1"></p>
                            <p v-html="langConfig.m3.info2"></p>
                        </div>
                    </div>
                    <div class="m_3_c_r">
                        <div class="swiperC">
                            <swiper :options="swiperOption2" ref="mySwiper2">
                                <swiper-slide
                                    ><img
                                        src="@/assets/imgs/pic/pic_2_1.jpg"
                                        alt="轮播图1"
                                /></swiper-slide>
                                <swiper-slide
                                    ><img
                                        src="@/assets/imgs/pic/pic_2_2.jpg"
                                        alt="轮播图2"
                                /></swiper-slide>
                                <swiper-slide
                                    ><img
                                        src="@/assets/imgs/pic/pic_2_3.jpg"
                                        alt="轮播图3"
                                /></swiper-slide>
                                <swiper-slide
                                    ><img
                                        src="@/assets/imgs/pic/pic_2_5.jpg"
                                        alt="轮播图5"
                                /></swiper-slide>
                            </swiper>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m m_4" id="m_4">
                <div class="m_c m_4_c">
                    <div class="m_c_title m_4_c_title">
                        <span>{{ langConfig.m4.entitle }}</span>
                        <p>{{ langConfig.m4.title }}</p>
                    </div>
                    <div class="m_4_c_c">
                        <ul>
                            <li
                                class="m_4_c_c_1"
                                @mouseover="m4Show1 = true"
                                @mouseout="m4Show1 = false"
                            >
                                <i></i>
                                <span>{{ langConfig.m4.li1.title }}</span>
                                <div class="text">
                                    <!-- <P>{{ langConfig.m4.li1.info }}</P> -->
                                    <P
                                        v-if="!m4Show1"
                                        v-html="langConfig.m4.li1.info1"
                                    ></P>
                                    <P
                                        v-else
                                        v-html="langConfig.m4.li1.info2"
                                    ></P>
                                </div>
                            </li>
                            <li
                                class="m_4_c_c_2"
                                @mouseover="m4Show2 = true"
                                @mouseout="m4Show2 = false"
                            >
                                <i></i>
                                <span>{{ langConfig.m4.li2.title }}</span>
                                <div class="text">
                                    <!-- <P>{{ langConfig.m4.li2.info }}</P> -->
                                    <P
                                        v-if="!m4Show2"
                                        v-html="langConfig.m4.li2.info1"
                                    ></P>
                                    <P
                                        v-else
                                        v-html="langConfig.m4.li2.info2"
                                    ></P>
                                </div>
                            </li>
                            <li
                                class="m_4_c_c_3"
                                @mouseover="m4Show3 = true"
                                @mouseout="m4Show3 = false"
                            >
                                <i></i>
                                <span>{{ langConfig.m4.li3.title }}</span>
                                <div class="text">
                                    <!-- <P>{{ langConfig.m4.li3.info }}</P> -->
                                    <P
                                        v-if="!m4Show3"
                                        v-html="langConfig.m4.li3.info1"
                                    ></P>
                                    <P
                                        v-else
                                        v-html="langConfig.m4.li3.info2"
                                    ></P>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="m m_5" id="m_5">
                <div class="m_c m_5_c">
                    <div class="m_c_title m_5_c_title">
                        <span>{{ langConfig.m5.entitle }}</span>
                        <p>{{ langConfig.m5.title }}</p>
                    </div>
                    <div class="m_5_c_c">
                        <ul>
                            <li class="m_5_c_c_1">
                                <div class="m_5_icon">
                                    <b></b>
                                    <i></i>
                                </div>
                                <span>{{ langConfig.m5.li1.title }}</span>
                                <div class="text">
                                    <P v-html="langConfig.m5.li1.info"></P>
                                </div>
                            </li>
                            <ol></ol>
                            <li class="m_5_c_c_2">
                                <div class="m_5_icon">
                                    <b></b>
                                    <i></i>
                                </div>
                                <span>{{ langConfig.m5.li2.title }}</span>
                                <div class="text">
                                    <!-- <P>{{ langConfig.m5.li2.info }}</P> -->
                                    <P v-html="langConfig.m5.li2.info"></P>
                                </div>
                            </li>
                            <ol></ol>
                            <li class="m_5_c_c_3">
                                <div class="m_5_icon">
                                    <b></b>
                                    <i></i>
                                </div>
                                <span>{{ langConfig.m5.li3.title }}</span>
                                <div class="text">
                                    <!-- <P>{{ langConfig.m5.li3.info }}</P> -->
                                    <P v-html="langConfig.m5.li3.info"></P>
                                </div>
                            </li>
                            <ol></ol>
                            <li class="m_5_c_c_4">
                                <div class="m_5_icon">
                                    <b></b>
                                    <i></i>
                                </div>
                                <span>{{ langConfig.m5.li4.title }}</span>
                                <div class="text">
                                    <!-- <P>{{ langConfig.m5.li4.info }}</P> -->
                                    <P v-html="langConfig.m5.li4.info"></P>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="m m_8 footer" id="m_8">
                <div class="footer_c">
                    <div class="footer_c_1">
                        <h1 class="logo" @click="link('m_1')">
                            <img
                                v-if="lang == 'zh-cn'"
                                src="@/assets/imgs/logo.png"
                                :alt="langConfig.h1"
                                width="100%"
                            />
                            <img
                                v-else-if="lang == 'zh-cht'"
                                src="@/assets/imgs/tc/logo.png"
                                :alt="langConfig.h1"
                                width="100%"
                            />
                            <img
                                v-else
                                src="@/assets/imgs/es/logo.png"
                                :alt="langConfig.h1"
                                width="100%"
                            />
                            <!-- 红匣子游戏 -->
                        </h1>
                    </div>
                    <div class="footer_c_2">
                        <ul>
                            <li>
                                <a @click="link('m_3')">{{
                                    langConfig.footNav[0]
                                }}</a>
                            </li>
                            |
                            <li>
                                <a @click="link('m_2')">{{
                                    langConfig.footNav[2]
                                }}</a>
                            </li>
                            |
                            <li>
                                <a
                                    :href="langConfig.footLink1"
                                    target="_blank"
                                    >{{ langConfig.footNav[3] }}</a
                                >
                            </li>
                            |
                            <li>
                                <a
                                    :href="langConfig.footLink2"
                                    target="_blank"
                                    >{{ langConfig.footNav[4] }}</a
                                >
                            </li>
                        </ul>
                        <p>
                            {{ langConfig.footInfo
                            }}<a
                                href="https://beian.miit.gov.cn"
                                target="_blank"
                                style="margin-left: 6rem"
                                >{{ langConfig.footIcp }}</a
                            ><br />
                            {{ langConfig.footAddress }}<br />
                            {{ langConfig.footEmail2 }}
                            <img src="../../assets/imgs/email.png" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { getPositionList } from "@/api";
import "@/assets/styles/index_pc.scss";
import Cookies from "js-cookie";
import langzhcn from "./config/zh-cn.json";
import langzhhk from "./config/zh-cht.json";
import langenus from "./config/en-us.json";
import langjajp from "./config/ja-jp.json";
import langkokr from "./config/ko-kr.json";
import { GetRequest } from "@/utils";

// 防刷
import debounce from "lodash/debounce";

// 滚动条// 引入
var VueScrollTo = require("vue-scrollto");

export default {
    name: "Home",
    components: {},
    data() {
        return {
            navIndex: 1,
            scroll: 0,
            lang: Cookies.get("lang") ? Cookies.get("lang") : "zh-cn",
            langNavShow: false,
            m1iconShow: false,
            m4Show1: false,
            m4Show2: false,
            m4Show3: false,
            recruitInfo: [],
            langConfig: langzhcn,
            swiperOption: {
                // autoplay : 100,//可选选项，自动滑动
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                loop: true, //可选选项，开启循环
                grabCursor: true,
            },
            swiperOption2: {
                // autoplay : 100,//可选选项，自动滑动
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                loop: true, //可选选项，开启循环
                grabCursor: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
        };
    },
    watch: {
        scrollHeight(curVal, oldVal) {
            //普通的watch监听
            console.log("scrollHeight: ", oldVal, curVal);
        },
    },
    mounted() {
        this.handleLoading();
        window.addEventListener("scroll", this.scrollDs, true);
    },
    methods: {
        /**
         * @function handleLoading 处理加载
         */
        async handleLoading() {
            console.log("初始化");
            // this.positionType()
            let urlRequest = GetRequest();
            console.log("urlRequest", urlRequest);
            console.log("urlRequest.navNum", urlRequest.navNum);
            switch (urlRequest.navNum) {
                case "1":
                    console.log("urlRequest1");
                    this.link("m_1");
                    break;
                case "2":
                    this.link("m_2");
                    break;
                case "3":
                    console.log("urlRequest4");
                    this.link("m_3");
                    break;
                case "4":
                    console.log("urlRequest4");
                    this.link("m_4");
                    break;
                case "5":
                    console.log("urlRequest5");
                    this.link("m_5");
                    break;
                default:
            }

            let url2 = window.location.pathname;
            let Dlang = process.env.VUE_APP_VERSION;
            console.log("url2: " + url2);
            console.log("Dlang: " + process.env.VUE_APP_VERSION);
            switch (Dlang) {
                case "zh":
                    this.lang = "zh-cn";
                    this.langConfig = langzhcn;
                    break;
                case "zh-cht":
                    this.lang = "zh-cht";
                    this.langConfig = langzhhk;
                    break;
                case "en":
                    this.lang = "en-us";
                    this.langConfig = langenus;
                    break;
                case "ja":
                    this.lang = "ja-jp";
                    this.langConfig = langjajp;
                    break;
                case "ko":
                    this.lang = "ko-kr";
                    this.langConfig = langkokr;
                    break;
                default:
            }

            // const cookieLang = Cookies.get('lang');
            // const browserLang = navigator.language.substring(0, 2);
            // const browserLang2 = navigator.language;
            // console.log('browserLang', browserLang)
            // console.log('browserLang2', browserLang2)
            // if (cookieLang) {
            // 	// this.setLang(cookieLang)
            // 	switch(cookieLang) {
            // 		case "zh-cn":
            // 			this.langConfig = langzhcn;
            // 		break;
            // 		case "zh-cht":
            // 			this.langConfig = langzhhk;
            // 		break;
            // 		case "en-us":
            // 			this.langConfig = langenus;
            // 		break;
            // 		case "ja-jp":
            // 			this.langConfig = langjajp;
            // 		break;
            // 		case "ko-kr":
            // 			this.langConfig = langkokr;
            // 		break;
            // 		default:
            // 	}
            // 	return
            // }
            // if (browserLang == 'zh') {
            // 	if (['zh-TW', 'zh-SG', 'zh-cht'].includes(browserLang2)) {
            // 		console.log('browserLang3', browserLang2)
            // 		this.setLang('zh-cht')
            // 		return
            // 	}
            // 	this.setLang('zh-cn')
            // 	return
            // }
            // if (browserLang == 'en') {
            // 	this.setLang('en-us')
            // 	return
            // }
            // if (browserLang == 'ko') {
            // 	this.setLang('ko-kr')
            // 	return
            // }
            // if (browserLang == 'ja') {
            // 	this.setLang('ja-jp')
            // 	return
            // }
            // console.log("Cookies.get('lang')", Cookies.get('lang'))
            // console.log("lang", this.lang)
            // this.setLang(this.lang)
        },

        /**
         * @function link 跳转位置
         */
        //js
        link(id) {
            let num = id.substr(2, 1);
            console.log("num", num);
            this.navIndex = num;
            console.log("navIndex", this.navIndex);
            VueScrollTo.scrollTo(document.getElementById(id), 1000, {
                offset: -110,
            });
        },

        /**
         * @function link 跳转位置
         */
        scrollDs() {
            this.scroll = document.documentElement.scrollTop;
            // console.log('scroll', this.scroll);
            let m1 = document.getElementById("m_1").offsetTop - 110;
            let m2 = document.getElementById("m_2").offsetTop - 110;
            let m3 = document.getElementById("m_3").offsetTop - 110;
            let m4 = document.getElementById("m_4").offsetTop - 110;
            let m5 = document.getElementById("m_5").offsetTop - 110;
            let m8 = document.getElementById("m_8").offsetTop - 110;
            setTimeout(() => {
                if (this.scroll >= 0 && this.scroll < m1) {
                    this.navIndex = 1;
                } else if (this.scroll >= m1 && this.scroll < m2) {
                    this.navIndex = 1;
                } else if (this.scroll >= m2 && this.scroll < m3) {
                    this.navIndex = 2;
                } else if (this.scroll >= m3 && this.scroll < m4) {
                    this.navIndex = 3;
                } else if (this.scroll >= m4 && this.scroll < m5) {
                    this.navIndex = 4;
                } else if (this.scroll >= m5  && this.scroll < m8) {
                    this.navIndex = 5;
                }
            }, 1000);
        },

        /**
         * @function setLang 设置语言
         */
        setLang(langType) {
            // Cookies.set('lang', langType)
            this.lang = langType;
            let url1 = window.location.host;
            let url2 = window.location.protocol;
            console.log("url2", url2);
            console.log("url3", url2 + "//" + url1 + "/zh/");
            switch (this.lang) {
                case "zh-cn":
                    // this.langConfig = langzhcn;
                    window.location.href = url2 + "//" + url1 + "/zh/";
                    break;
                case "zh-cht":
                    // this.langConfig = langzhhk;
                    window.location.href = url2 + "//" + url1 + "/zh-cht/";
                    break;
                case "en-us":
                    // this.langConfig = langenus;
                    window.location.href = url2 + "//" + url1 + "/en/";
                    break;
                case "ja-jp":
                    // this.langConfig = langjajp;
                    window.location.href = url2 + "//" + url1 + "/ja/";
                    break;
                case "ko-kr":
                    // this.langConfig = langkokr;
                    window.location.href = url2 + "//" + url1 + "/ko/";
                    break;
                default:
            }
        },

        /**
         * @function positionType 岗位类别
         */
        positionType() {
            getPositionList({ lang: "zh-cn", pageSize: 4, pageIndex: 1 })
                .then((res) => {
                    console.log("岗位类别成功", res);
                    console.log("岗位类别成功", res.data.list);
                    this.recruitInfo = res.data.list;
                })
                .catch((err) => {
                    console.log("岗位类别失败", err);
                });
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/styles/index_pc.scss";
</style>
